import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { baseQuery } from 'commons/src/api/baseQuery';
import fetch from 'commons/src/api/fetch';
import getFetchHeaders from 'commons/src/api/getFetchHeaders';
import { SensorTypes, ThresholdType, ThresholdsResourceScope } from 'commons/src/models/commonEnums';
import { SpaceThresholds } from 'commons/src/models/customThresholdModels';

export interface ThresholdConfig {
    value: number;
    thresholdType: ThresholdType;
}

export interface ThresholdConfigSensor {
    sensor: keyof typeof SensorTypes;
    thresholds: ThresholdConfig[];
}

export interface UpdateThresholdsRequest {
    resourceScope: ThresholdsResourceScope;
    id: string;
    sensors: ThresholdConfigSensor[];
}

export const updateThresholdsApi = async (request: UpdateThresholdsRequest): Promise<void> =>
    fetch(`/thresholds`, {
        method: 'PUT',
        headers: await getFetchHeaders(),
        body: JSON.stringify(request),
    });

export const thresholdsApi = createApi({
    reducerPath: 'thresholds',
    baseQuery,
    tagTypes: ['Thresholds'],
    endpoints: builder => ({
        getThresholds: builder.query<SpaceThresholds, { resourceId: string; scope: ThresholdsResourceScope }>({
            query: ({ resourceId, scope }) => ({
                url: `/thresholds?resourceScope=${scope}&resourceId=${resourceId}`,
                method: 'GET',
            }),
            transformResponse: (response: { thresholds: SpaceThresholds }): SpaceThresholds => {
                return response.thresholds;
            },
            providesTags: ['Thresholds'],
        }),
        updateThresholds: builder.mutation<void, UpdateThresholdsRequest>({
            query: request => ({
                url: '/thresholds',
                method: 'PUT',
                headers: getFetchHeaders(),
                data: request,
            }),
        }),
    }),
});

export const { useGetThresholdsQuery, useUpdateThresholdsMutation } = thresholdsApi;
